import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquare, faCheckSquare } from '@fortawesome/free-regular-svg-icons'
import { Label } from '../atoms/Label'
import clsx from 'clsx'

export const CheckboxToggleRemix = ({ label, checked, onChange, disabled = false, ...props }) => {
  return (
    <label className={clsx('flex justify-start items-center space-x-2', disabled && 'opacity-30')} onClick={disabled ? undefined : onChange}>
      {!checked && <FontAwesomeIcon icon={faSquare} />}
      {checked && <FontAwesomeIcon icon={faCheckSquare} />}
      <div className="select-none sm:text-base md:text-xl font-normal">{label}</div>
    </label>
  )
}

export const CheckboxToggleLarge = ({ label, checked, onChange, ...props }) => {
  return (
    <div className="flex justify-start items-center space-x-2 cursor-pointer" onClick={onChange}>
      {!checked && <FontAwesomeIcon icon={faSquare} className="text-2xl" />}
      {checked && <FontAwesomeIcon icon={faCheckSquare} className="text-2xl" />}
      <Label small>{label}</Label>
    </div>
  )
}

// Keep default export for backward compatibility
export default CheckboxToggleRemix
